export default function DmcaContent() {
  return (
    <>
      <p>
        <strong>Last updated:</strong> August 31, 2026
      </p>

      <h2>1. Copyright notices</h2>
      <p>
        A copyright owner or authorized agent may request removal or disabling
        of allegedly infringing material by sending a written notice that
        includes:
      </p>
      <ul>
        <li>a physical or electronic signature;</li>
        <li>
          identification of the copyrighted work, or a representative list for
          multiple works;
        </li>
        <li>
          identification and location of the allegedly infringing material with
          enough detail for Lutely to locate it, including relevant URLs, Artist
          names, album or track titles, or account identifiers;
        </li>
        <li>
          the complaining party&apos;s name, address, telephone number, and
          email address;
        </li>
        <li>
          a statement of good-faith belief that the disputed use is not
          authorized by the copyright owner, its agent, or the law; and
        </li>
        <li>
          a statement, under penalty of perjury, that the notice is accurate and
          that the complaining party is the copyright owner or authorized to act
          for the owner.
        </li>
      </ul>
      <p>
        Incomplete notices may be ineffective. A person who knowingly materially
        misrepresents that material is infringing may be liable under 17 U.S.C.
        § 512(f).
      </p>

      <h2>2. Lutely&apos;s response</h2>
      <p>
        Lutely may remove or disable access to material identified in a
        compliant notice, notify the affected User, suspend sales and payouts,
        preserve relevant funds and records, and take other reasonable action.
        Removal may affect listings, streaming, downloads, redownloads, Artist
        pages, artwork, lyrics, and other Platform content.
      </p>
      <p>
        Lutely may forward the notice and the complainant&apos;s contact
        information to the affected User as permitted by law.
      </p>

      <h2>3. Counter-notices</h2>
      <p>
        A User who believes material was removed or disabled because of mistake
        or misidentification may send a counter-notice containing:
      </p>
      <ul>
        <li>the User&apos;s physical or electronic signature;</li>
        <li>identification of the removed material and its former location;</li>
        <li>
          the User&apos;s name, address, telephone number, and email address;
        </li>
        <li>
          a statement under penalty of perjury that the User has a good-faith
          belief the material was removed or disabled by mistake or
          misidentification; and
        </li>
        <li>
          a statement consenting to the jurisdiction of the appropriate federal
          district court and accepting service of process from the person who
          submitted the original notice.
        </li>
      </ul>
      <p>
        Lutely may provide a compliant counter-notice to the original claimant
        and may restore the material after the statutory waiting period unless
        the claimant informs Lutely that a court action has been filed.
      </p>

      <h2>4. Repeat infringers</h2>
      <p>
        Lutely may suspend or terminate Users who repeatedly infringe copyrights
        or who repeatedly submit unauthorized material. Lutely may consider the
        number, timing, severity, and credibility of claims and other relevant
        circumstances.
      </p>

      <h2>5. Prior purchasers</h2>
      <p>
        A takedown may require Lutely to disable access for prior purchasers.
        Lutely may determine whether legally permissible access can continue,
        whether a replacement or refund is appropriate, and whether funds should
        be withheld or recovered from the applicable Artist.
      </p>

      <h2>6. Designated agent</h2>
      <p>
        Notices and counter-notices should be sent to Lutely&apos;s designated
        copyright agent using the contact information published in the U.S.
        Copyright Office directory and on Lutely&apos;s website:
      </p>
      <p>
        Copyright Agent
        <br />
        License Lounge, Inc. d/b/a Lutely
        <br />
        169 Madison Avenue
        <br />
        Suite 2303
        <br />
        New York, NY 10016
        <br />
        Phone: 313-241-8483
        <br />
        Email: <a href="mailto:copyright@lutely.com">copyright@lutely.com</a>
      </p>
    </>
  );
}
